import React from 'react';

import './Toggle.scss';
import Icon from 'Core/Components/Icon';

class Toggle extends React.Component {
  constructor (props) {
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle () {
    const { value, onChange } = this.props;
    if (typeof onChange === 'function') onChange(!value);
  }

  render () {
    const { value, label, icon, onChange, tabIndex, disabled, children, className } = this.props;

    return (
      <stack className={'Field Toggle-Wrapper' + (className ? ' ' + className : '')}>
        <div className={'Toggle' + (disabled ? ' disabled' : '') + (value ? ' On' : ' Off')}  onClick={this.handleToggle}>
          {!icon ? null : (
            <box className="Toggle-Icon">
              <Icon fa={icon} />
            </box>
          )}
          <box className="Toggle-Text">
            <box className="Toggle-Indicator">
              <Icon fa={value ? 'toggle-on' : 'toggle-off'} />
            </box>
            <label>{label}</label>
          </box>
          {/* <input
            type="checkbox"
            tabIndex={0}
            checked={value}
            value={value}
            onChange={this.handleToggle}
          /> */}
          {/* <mark className={value ? 'on' : 'off'}>{value ? 'ON' : 'OFF'}</mark> */}
          {!disabled ? null : (
            <box className="Toggle-Attribute"><Icon fa="ban o3" /></box>
          )}
        </div>
      </stack>
    );
  }
};

export default Toggle;



// WEBPACK FOOTER //
// ./client/RLX/Forms/Toggle/Toggle.jsx